import styled from "styled-components";

export const Sekcja = styled.section`
  display: grid;
  grid-template-columns: minmax(320px, .85fr) minmax(0, 1.15fr);
  gap: clamp(30px, 5vw, 70px);
  padding: 90px clamp(16px, 5vw, 72px);
  align-items: center;
  background: #f8faf7;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 20px;
    padding: 70px 16px;
    justify-items: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    gap: 10px;
    padding-top: 64px;
    padding-bottom: 64px;
  }
`;

export const Zdjecie = styled.img`
  width: 100%;
  max-width: 560px;
  height: min(680px, 75vh);
  object-fit: cover;
  border-radius: 30px;
  box-shadow: 0 28px 70px rgba(31,55,36,.16);

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    order: 2; 
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    height: 360px;
    border-radius: 24px;
  }
`;

export const Naglowek = styled.div`
  display: flex;
  flex-direction: column;
  `;

export const Paragraf = styled.div`
  display: grid;
  grid-template-columns: 38px 1fr;
  gap: 15px;
  padding: 18px 0;
  border-bottom: 1px solid #dde2dc;
`;

export const Artykul = styled.div`
  display: grid;
`;

export const Podtytul = styled.h4`
  margin-top: 0;
  margin-bottom: 0;
  line-height: 30px;
  font-size: 20px;
`;

export const StepButton = styled.button`
  display:flex;align-items:center;justify-content:space-between;gap:15px;width:100%;padding:0;border:0;background:transparent;color:inherit;font:inherit;text-align:left;cursor:default;
  @media(max-width:${({theme})=>theme.breakpoint.mobileMax}px){cursor:pointer;&:focus-visible{outline:3px solid ${({theme})=>theme.color.orange};outline-offset:4px;border-radius:6px;}}
`;

export const StepArrow = styled.span`
  display:none;
  @media(max-width:${({theme})=>theme.breakpoint.mobileMax}px){display:grid;place-items:center;flex:0 0 30px;width:30px;height:30px;border-radius:50%;background:#eaf1e8;color:${({theme})=>theme.color.green};font-size:21px;}
`;

export const Numer = styled.div`
  width: 38px;
  height: 38px;
  background: ${({ theme }) => theme.color.orange};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 700;
  margin-right: 20px;
`;

export const Tytul = styled.h2`
  display: grid;
  gap: 10px;
  margin: 0 0 22px;

  span { color: ${({ theme }) => theme.color.green}; font-size: 13px; font-weight: 900; letter-spacing: .09em; text-transform: uppercase; }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    padding-left: 8px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    padding-left: 0;
    font-size: 31px;
    line-height: 1.08;
  }
`;

export const Opis = styled.p`
  margin-top: 5px;
  margin-bottom: 10px;
  color: #606560;
  line-height: 1.55;
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    display: ${({$open})=>$open?"block":"none"};
    animation: ${({$open})=>$open?"stepReveal 180ms ease both":"none"};
  }
  @keyframes stepReveal { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: none; } }
  @media (prefers-reduced-motion: reduce) { animation: none !important; }
`;

